<template>
  <div>
    <title>库存调拨记录</title>
    <section class="mainPart">
      <!--S 头部tab，注意：门店库存调拨记录有头部，总部的没有-->
      <header class="tabHeader">
        <p>
          <router-link v-if="userInfoMd.isopencardstock==1" :to="{name:'券卡库存'}">券卡库存</router-link>
          <router-link :to="{name:'单品库存'}">单品库存</router-link>
          <a v-if="userInfoMd.cantransferinv==1" href="javascript:;" class="isActive">单品库存调拨记录</a>
        </p>
      </header>
      <!--E 头部tab-->
      
      <!--S 检索-->      
      <el-form inline :model="formInline" class="searchForm"><!--注意：门店库存调拨记录有头部有类名searchForm，总部的没有头部，则无类名---->
        <el-form-item label="调拨时间">
          <!-- S 双日期选择器 -->
          <TwoDatePicker :type=1  @twoDateObtain="twoDateReceive" :startvaldate="formInline.startdate" :endvaldate="formInline.enddate"></TwoDatePicker>
          <!-- E 双日期选择器 -->
        </el-form-item>
        <el-form-item label="单品">
          <SingleSelect :singlecode="formInline.singlecode" @singleObtain="singleChange"></SingleSelect>
        </el-form-item>
        <el-form-item label="调拨方">
          <FlowSelectPage :type="0" eleType="库存调拨" @flowObtain="transferReceive"></FlowSelectPage>
        </el-form-item>
        <el-form-item label="接收方">
          <FlowSelectPage :type="0" @flowObtain="receiverReceive"></FlowSelectPage>
        </el-form-item>    
        <el-form-item label="状态">
          <el-select v-model="formInline.transferstate" filterable placeholder="请选择或输入" clearable>
            <el-option label="待确认" :value="0"></el-option>
            <el-option label="调拨成功" :value="1"></el-option>
            <el-option label="调拨失败" :value="2"></el-option>
            <el-option label="调拨取消" :value="3"></el-option>
          </el-select>
        </el-form-item> 
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <!--E 检索-->    
      <!--S 库存管理列表-->
      <el-table :data="singleGoodsTransferData" v-loading="loading" ref="singleGoodsInv" class="orderTable comTable" border :maxHeight="tableHeight">         
        <el-table-column type="index" label="序号" fixed></el-table-column>
        <el-table-column label="状态" prop="transferstate" sortable min-width="200">
          <template slot-scope="scope">
            <p :class="[{'orangeColor':scope.row.transferstate == 0&&scope.row.fromcode!=mdflowcode},{'redColor':scope.row.transferstate == 0&&scope.row.fromcode==mdflowcode},{'greyColor':scope.row.transferstate == 2 || scope.row.transferstate == 3},{'blueColor':scope.row.transferstate == 1}]">{{scope.row.transferstate | transferstateFilter}}</p>
            <small class="greyColor">{{dateTime(scope.row.credate,1)}}</small>
          </template>
        </el-table-column>
        <el-table-column label="调拨方" prop="fromname" sortable min-width="250">
          <template slot-scope="scope">
            <p class="textFl pdr70" :title="scope.row.fromname">{{scope.row.fromname ||'--'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="接收方" prop="receivename" sortable min-width="250">
          <template slot-scope="scope">
            <p class="textFl pdr70" :title="scope.row.receivename">{{scope.row.receivename ||'--'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="单品" prop="singlename" sortable min-width="300">
          <template slot-scope="scope">
            <p class="textFl pdr70" :title="scope.row.singlename">{{scope.row.singlename}}</p>
          </template>
        </el-table-column>
        <el-table-column label="调拨库存" prop="num" sortable min-width="150">
          <template slot-scope="scope">
            <!--注意：总部的库存调拨记录无颜色区分和+-号区分-->
            <span class="fw600" :class="scope.row.receivecode==mdflowcode?'greenColor':'redColor'">{{scope.row.receivecode==mdflowcode?'+':'-'}}{{scope.row.num}}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="memo" sortable min-width="250">
          <template slot-scope="scope">
            <p class="textFl pdr70" :title="scope.row.memo||''">{{scope.row.memo||'--'}}</p>
            <small class="greyColor">操作人：{{scope.row.operuname ||'--'}}</small>
          </template>
        </el-table-column>
        <el-table-column label="审核说明" min-width="250">
          <template slot-scope="scope">
            <p class="textFl pdr70" :title="scope.row.transfeedback">{{scope.row.transfeedback?scope.row.transfeedback:'--'}}</p>
            <small v-if="scope.row.transferstate != 0&&scope.row.transferstate != 3">{{dateTime(scope.row.upddate,1)}}</small>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <p class="handle">
              <span title="详情" @click="viewDetail(scope.row.transfercode)"><i class="icondetails"></i></span>
              <el-popover placement="bottom" width="300" trigger="click" v-if="scope.row.transferstate == 0&&scope.row.fromcode==mdflowcode"  @show="transferShowPop(scope.$index,scope.row)" >
                <div class="invoiceNoBox">
                  <p>
                    <em>调拨库存：</em>
                    <el-input v-model="scope.row.transferVal" maxlength="9" placeholder="修改调拨库存" clearable @input="numChange(scope.row)"></el-input>
                  </p>
                  <p>
                    <el-button type="primary" size="mini" @click="closeTransferPop(scope.row,'编辑')">确定</el-button>
                    <el-button size="mini" @click="closeTransferPop(scope.row,0)">取消</el-button>
                  </p>
                </div>
                <span title="编辑" slot="reference" class="mr0"><i class="iconedit"></i></span>
              </el-popover>
              <el-popover placement="bottom" width="300" trigger="click" v-if="scope.row.transferstate == 0&&scope.row.receivecode==mdflowcode" @show="transferShowPop(scope.$index)">
                <el-form class="settleForm" :model="settleForm" label-width="80px" :rules="verifyRules" ref="settleForm">
                  <el-form-item label="审核">
                    <el-radio-group v-model="settleForm.checkStatu">
                      <el-radio :label="1" :value="1">审核通过</el-radio>
                      <el-radio :label="2" :value="2" >审核不通过</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="备注" v-show="settleForm.checkStatu == 1">
                    <el-input type="textarea" v-model="settleForm.memo" clearable placeholder="填写备注" maxlength="50"></el-input>
                  </el-form-item>
                  <el-form-item label="备注" prop="memo" v-show="settleForm.checkStatu == 2">
                    <el-input type="textarea" v-model="settleForm.memo" clearable placeholder="填写备注" maxlength="50"></el-input>
                  </el-form-item> 
                </el-form>
                <div class="center">
                  <el-button type="primary" size="mini" @click="closeTransferPop(scope.row,'审核')">确定</el-button>
                  <el-button size="mini" @click="closeTransferPop(scope.row,0)">取消</el-button>
                </div>
                <span title="审核" slot="reference" class="mr0"><i class="iconsh"></i></span>
              </el-popover>
              <span title="取消调拨" @click="cancel(scope.row)" v-if="scope.row.transferstate==0&&scope.row.fromcode==mdflowcode"><i class="iconjian"></i></span>
            </p>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="noData"><span>暂无数据</span></div>
        </template>
      </el-table>
      <!--E 库存管理列表-->
       <!-- S 分页 -->
        <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
       <!-- E 分页 -->
    </section>

    <!--S 调拨记录详情-->
    <el-dialog :visible.sync="transferDetailShow" class="comDlog seniorMdg" title="调拨记录详请" :modal-append-to-body="false" append-to-body :close-on-click-modal="false">
      <div class="flexAro basicWrap">
        <ul>
          <li class="rulrMemo">
            <em>单品：</em>
            <b :title="transferInfo.singlename||''">{{transferInfo.singlename ||'--'}}</b>
          </li>
          <li>
            <em>调拨库存：</em>
            <b class="fw600" :class="transferInfo.receivecode==mdflowcode?'greenColor':'redColor'">{{transferInfo.num}}</b>
          </li>
          <li class="rulrMemo">
            <em>调拨方：</em>
            <b :title="transferInfo.fromname||''">{{transferInfo.fromname ||'--'}}</b>
          </li>
          <li class="rulrMemo">
            <em>接收方：</em>
            <b :title="transferInfo.receivename||''">{{transferInfo.receivename ||'--'}}</b>
          </li>
          <li class="rulrMemo">
            <em>备注：</em>
            <b :title="transferInfo.memo||''">{{transferInfo.memo ||'--'}}</b>
          </li>
          <li>
            <em>调拨时间：</em>
            <b>{{dateTime(transferInfo.credate,1)}}</b>
          </li>
          <li :class="[{'orangeColor':transferInfo.transferstate == 0&&transferInfo.fromcode!=mdflowcode},{'redColor':transferInfo.transferstate == 0&&transferInfo.fromcode==mdflowcode},{'greyColor':transferInfo.transferstate == 2 || transferInfo.transferstate == 3},{'blueColor':transferInfo.transferstate == 1}]">
            <em>状态：</em>
            {{transferInfo.transferstate | transferstateFilter}}
          </li>
          <li class="rulrMemo">
            <em>审核说明：</em>
            {{transferInfo.transfeedback?transferInfo.transfeedback:'--'}}
          </li>
          <li class="rulrMemo">
            <em>操作人：</em>
            <b :title="transferInfo.operuname||''">{{transferInfo.operuname||'--'}}</b>
          </li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="transferDetailShow = false">关闭</el-button>
      </div>
    </el-dialog>
    <!--E 调拨记录详情-->

  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import Api from '@/apis/api';
export default {
  name: 'InventoryTransferRecord',
  data () {
    return {
      loading:false,
      mdflowcode:'',
      pageSize: 30, // 每页展示的条数
      currentPage: 1, // 当前请求的页数
      pagebBean: {
        totalnum: 0,
      }, // 获取到的列表分页信息
     
      formInline:{
        startdate: "", //调拨时间
        enddate:'',
        singlecode:'',
        fromcode:'', //调拨方
        receivecode:'', //接收方
        transferstate:'',//调拨状态
      },//检索表单
      singleGoodsTransferData:[
      ],//单品库存数据
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      transferDetailShow:false,//调拨记录详情弹窗
      transferInfo:{},//调拨记录详情对象
      settleForm:{//审核表单
        checkStatu:1,
        memo:''
      },
      firstTrue: true, // 防止多次点击
      totalNum: 0, // 单品剩余的库存
      verifyRules: {
        memo: [
          { required: true, message: "审核说明不能为空！", trigger: ['blur']},
        ]
      },
      userInfoMd:'',
    }
  },
  components: {
    // goodOne: resolve => require(["@/components/common/goodOne.vue"], resolve),
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    TwoDatePicker: resolve =>require(["@/components/common/TwoDatePicker.vue"], resolve), // 双日期选择器组件
    FlowSelectPage:resolve => require(["@/components/GoodsFolder/GoodsSingle/FlowSelectPage.vue"],resolve), // 流向方下拉组件（带分页）
    SingleSelect: resolve => require(["@/components/GoodsFolder/GoodsSingle/SingleSelect.vue"], resolve), // 单品下拉选择组件
  },
  filters:{
    // 状态过滤
    transferstateFilter(val){
      if(val == 0){
        return '待确认'
      }else if(val == 1){
        return '调拨成功'
      }else if(val == 2){
        return '调拨失败'
      }else if(val == 3){
        return '调拨取消'
      }
    }
  },
  watch: {
    'settleForm.checkStatu'(val) {
      this.settleForm.memo = '';
      this.$refs.settleForm.clearValidate();
    }
  },
  methods: {
    // 改变单品时
    singleChange(val) {
      this.formInline.singlecode = val;
    },
    // 接收选中的调拨方
    transferReceive(val) {
      this.formInline.fromcode = val;
    },
    // 接收选中的接收方
    receiverReceive(val) {
      this.formInline.receivecode = val;
    },
    // 调拨记录审核/取消
    auditTransfer(row,type) {
      if(this.firstTrue) {
        let auditParams = {
          transfercode: row.transfercode,
          transferstate: type!='取消'?this.settleForm.checkStatu:3,
          transfeedback: this.settleForm.memo
        }
        Api.AUDITTRANSFER(auditParams).then(res => {
          if(res.data.status == "200") {
            this.$message({
              type: 'success',
              message: res.data.message
            })
            if(type!='取消') {
              this.closeValue(row);
            }
            this.getTransferList();
          }else {
            this.$message({
              type: 'error',
              message: res.data.message
            })
          }
        })
      }
    },
    // 修改调拨库存时
    numChange(row) {
      row.transferVal=String(row.transferVal).replace(/^0(0+)|[^\d]+/g,'');
      if(Number(row.transferVal)>this.totalNum) {
        row.transferVal = this.totalNum;
      }
    },
    // 获取单品列表信息
    getSingleitemList(row){
      let param = {
        keyword: row.singlename
      }
       Api.GET_SINGLEITEMLIST1(param).then(res =>{
        if(res.data.status=="200"){
          if(res.data.data && res.data.data != 'null') {
            let info = res.data.data[0];
            this.totalNum = row.num + info.totalinv;
          }
        }
       })
    },
    senderObtain1(val){
      this.formInline.singlecode = val;
    },
    senderObtain2(val){
      this.formInline.fromcode = val;
    },
    senderObtain3(val){
      this.formInline.receivecode = val;
    },
    // 选择的日期
    twoDateReceive(val) {
      if(val){
        this.formInline.startdate = this.dateTime(val[0],1);
        this.formInline.enddate = this.dateTime(val[1],1);
      }else{
        this.formInline.startdate = '';
        this.formInline.enddate = '';
      }
    },
    //查看详情
    viewDetail(transfercode){
       Api.GET_TRANSFERDETAIL({transfercode:transfercode}).then(res =>{
          if(res.data.status=="200"&&res.data.data!=null){
            this.transferInfo = res.data.data;
            this.transferDetailShow = true;
          }else{
             this.transferInfo = {};
          }
       })
    },
    //关闭气泡
    closeTransferPop(row,val){
      if(val!=0){
        if(val == '编辑') {
          if(!row.transferVal) {
            this.$message({
              type: 'error',
              message: '调拨库存不能小于0!'
            })
            return false;
          }
          if(this.firstTrue) {
            let editParams = {
              transfercode: row.transfercode,
              num: row.transferVal
            }
            this.firstTrue = false;
            Api.EDITTRANSFER(editParams).then(res => {
              this.firstTrue = true;
              if(res.data.status == "200") {
                this.$message({
                  type: 'success',
                  message: res.data.message
                })
                this.closeValue(row);
                this.getTransferList();
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                })
              }
            })
          }
        } else if (val == '审核') {
          if(this.settleForm.checkStatu == 2 && this.settleForm.memo === '') {
            this.$message({
              type: 'error',
              message: '审核不通过说明不能为空!'
            })
            return false;
          }
          // 调拨记录审核/取消
          this.auditTransfer(row)
        }
      }else{
        //取消输入
        this.closeValue(row);
      }
    },
    // 打开气泡
    transferShowPop(index,row){
      // 清空值
      this.settleForm.checkStatu = 1;
      this.settleForm.memo = '';
      if(row) {
        // 获取单品列表信息
        this.getSingleitemList(row);
        this.$set(this.singleGoodsTransferData[index],'transferVal',row.num)
        // this.singleGoodsTransferData[index].transferVal = row.num;
      }
    },
    // 清空气泡
    closeValue(row) {
      row.transferVal = '';
      this.settleForm.checkStatu = 1;
      this.settleForm.memo = '';
      document.querySelector("#app").click(); //为了点击空白处关闭弹框
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.singleGoodsInv.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
    },
    // 接收分页信息
    updatePage(size,num) {
        this.pageSize = size;
        this.currentPage = num;
        this.getTransferList();
    },
    search(){
      this.currentPage =1;
      this.getTransferList();
    },
    getTransferList(){
       this.loading  =true;
      let param ={
        startdate:this.formInline.startdate,
        enddate:this.formInline.enddate,
        singlecode:this.formInline.singlecode,
        fromcode:this.formInline.fromcode,
        receivecode:this.formInline.receivecode,
        transferstate: this.formInline.transferstate!==''?this.formInline.transferstate:null,
        pageparam:{
          pagesize: this.pageSize, //每页条数
          currentpage: this.currentPage, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        }   
      }
      Api.GET_TRANSFERLIST(param).then(res =>{
         if(res.data.status=="200"){
            this.loading  =false;
            this.singleGoodsTransferData = res.data.data;
            this.pagebBean = res.data.pagebean;
            this.$refs.singleGoodsInv.bodyWrapper.scrollTop = 0;
          }else{
            this.loading  =false;
            this.pagebBean.totalnum =0;
            this.singleGoodsTransferData =[];
          }
      })
    },
    // 取消调拨
    cancel(row){
      MessageBox.confirm("确定要取消调拨吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 调拨记录审核/取消
        this.auditTransfer(row,'取消')
      }).catch(() => {
      });
    },
  },
  created() {
    if(this.$route.query.status==0){
      this.formInline.transferstate = 0
    }
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted (){
    if(localStorage.getItem('userInfoMd')){
      this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
       let flowcode = this.userInfoMd.flowcode;
       if(this.userInfoMd.objtype!=0) {
         flowcode = this.userInfoMd.pflowcode;
       }
       this.mdflowcode = flowcode;
    }
    if(this.$route.params.singlecode!=0){
      this.formInline.singlecode = this.$route.params.singlecode
    }else{
       this.formInline.singlecode = '';
    }
    this.getTransferList();
    //在dom渲染之后
    setTimeout(() => {
      this.getHeight();
    }, 200); 
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
.searchForm {padding-top:64px;}
.mainPart {padding: 20px; height: calc(100% - 50px);}
.pdr70 {padding-right:70px;width:auto;}
/*调拨记录详情弹窗 start*/
.seniorMdg >>> .el-dialog {width:600px;}
.basicWrap ul{padding:0 35px}
.basicWrap ul li{margin:20px 0}
.basicWrap ul li:first-child{margin-top:10px}
.basicWrap ul li>em{color:#333;width:120px;display:inline-block;text-align:right;vertical-align:top}
.basicWrap ul li b{color:#999}
.rulrMemo{display: -webkit-flex; display: flex;}
.rulrMemo b{min-width:calc(100% - 120px)}
.fw600 {font-weight: 600; font-size: 16px;}
/*调拨记录详情弹窗 end*/
.center{text-align: center;}
.invoiceNoBox {padding:10px;}
.invoiceNoBox p:first-child {display:-o-flex;display:-ms-flex;display:-moz-flex;display:-webkit-flex;display:flex; margin-bottom:20px; align-items: center;}
.invoiceNoBox p em {width:120px;text-align: right;}
.invoiceNoBox p:last-child {padding-left:84px;}
.invoiceNoBox p .el-buttom {margin-left:10px;}
.handle span.mr0{margin-right: 0!important;}
</style>



// WEBPACK FOOTER //
// src/views/InventoryMange/InventoryTransferRecord.vue